var _g, _path, _path2, _path3, _circle, _circle2, _circle3, _g2, _g3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateAppIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 230,
    viewBox: "0 0 385 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#createAppIllustration_svg__filter0_d_2325_132633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 12a4 4 0 014-4h310a4 4 0 014 4v204a6 6 0 01-6 6H39a6 6 0 01-6-6V12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.065 117.294l3.857-4.126c-3.526-.608-5.069-4.418-2.975-6.623 3.195-3.366 8.594-13.03 18.621-3.366l-3.526 3.909c9.586 4.125-.881 11.617-3.856 13.789-3.857 2.28-12.121 1.086-12.121-3.583z",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 51a4 4 0 014-4h13a4 4 0 014 4v13a4 4 0 01-4 4h-13a4 4 0 01-4-4V51z",
    fill: "#E3E7F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 8a6 6 0 016-6h306a6 6 0 016 6v16H33V8z",
    fill: "#E3E7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 9a2 2 0 012-2h121a2 2 0 012 2v8a2 2 0 01-2 2H134a2 2 0 01-2-2V9z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.76 13.38V15h-.531v-3.636h.524v1.353h.033a.787.787 0 01.293-.35.924.924 0 01.515-.13c.187 0 .351.039.49.116.141.077.25.191.327.344.078.152.117.341.117.568V15h-.531v-1.67c0-.2-.051-.356-.154-.466-.103-.111-.246-.167-.43-.167a.701.701 0 00-.337.08.58.58 0 00-.233.234.767.767 0 00-.083.37zm2.715 2.643a1.107 1.107 0 01-.363-.059l.128-.435a.86.86 0 00.26.034.31.31 0 00.2-.085.659.659 0 00.156-.261l.066-.181-.998-2.763h.568l.691 2.116h.029l.69-2.116h.57l-1.124 3.091a1.22 1.22 0 01-.199.36.769.769 0 01-.287.224.943.943 0 01-.387.075zm3.547.056c-.217 0-.403-.028-.559-.085a1.073 1.073 0 01-.38-.225.945.945 0 01-.221-.307l.457-.189c.032.053.074.108.128.166a.65.65 0 00.22.15.892.892 0 00.36.063.81.81 0 00.499-.148c.131-.097.197-.252.197-.465v-.536h-.034a1.23 1.23 0 01-.138.193.748.748 0 01-.245.185.912.912 0 01-.407.078c-.215 0-.409-.05-.582-.15a1.064 1.064 0 01-.408-.45 1.62 1.62 0 01-.15-.733c0-.29.05-.539.148-.746.099-.207.235-.366.408-.476.173-.111.369-.167.588-.167.169 0 .306.029.41.085a.75.75 0 01.243.196c.059.074.105.14.137.197h.039v-.442h.52v2.787c0 .235-.054.427-.163.577a.96.96 0 01-.442.334 1.706 1.706 0 01-.625.108zm-.005-1.56a.68.68 0 00.387-.107.663.663 0 00.241-.309c.056-.135.084-.296.084-.484 0-.184-.028-.345-.082-.485a.727.727 0 00-.24-.327.629.629 0 00-.39-.119.633.633 0 00-.4.124.742.742 0 00-.241.334 1.31 1.31 0 00-.08.473c0 .178.027.335.081.47.055.135.135.24.242.316.108.076.24.114.398.114zm1.947.481v-2.727h.513v.433h.029a.659.659 0 01.263-.346.75.75 0 01.429-.128 2.377 2.377 0 01.226.012v.508a.934.934 0 00-.114-.02 1.078 1.078 0 00-.163-.012.695.695 0 00-.336.08.596.596 0 00-.316.534V15h-.531zm2.689.06c-.173 0-.33-.032-.469-.096a.784.784 0 01-.332-.282.806.806 0 01-.121-.453c0-.153.03-.28.089-.38a.657.657 0 01.239-.236c.101-.058.214-.101.338-.131.124-.03.251-.052.38-.068l.398-.046a.584.584 0 00.221-.062c.047-.028.07-.074.07-.138v-.013a.479.479 0 00-.132-.36c-.086-.085-.215-.128-.387-.128-.178 0-.319.04-.422.119a.636.636 0 00-.212.26l-.499-.113c.06-.165.146-.3.26-.401.115-.103.246-.178.396-.224a1.546 1.546 0 01.816-.032c.124.025.238.071.345.139a.757.757 0 01.264.29.994.994 0 01.103.484V15h-.518v-.373h-.021a.763.763 0 01-.155.202.83.83 0 01-.264.166 1.028 1.028 0 01-.387.065zm.115-.426a.76.76 0 00.376-.087.603.603 0 00.324-.53v-.352a.278.278 0 01-.111.053 1.726 1.726 0 01-.182.04 27.9 27.9 0 01-.364.052 1.317 1.317 0 00-.283.066.483.483 0 00-.202.133.332.332 0 00-.075.227c0 .132.049.231.146.299.097.066.221.1.371.1zm1.938 1.389v-3.75h.518v.442h.044c.031-.057.076-.123.134-.197a.752.752 0 01.241-.196.844.844 0 01.408-.085c.221 0 .417.056.59.167.173.111.308.272.406.481.1.21.15.462.15.757 0 .294-.049.547-.148.758-.098.21-.233.371-.405.485a1.045 1.045 0 01-.587.168.868.868 0 01-.407-.083.768.768 0 01-.245-.196 1.507 1.507 0 01-.137-.198h-.032v1.447h-.53zm.52-2.387c0 .192.028.36.083.505a.764.764 0 00.242.339c.105.08.234.12.387.12a.62.62 0 00.397-.126.776.776 0 00.242-.346c.056-.145.083-.31.083-.492 0-.18-.027-.341-.081-.484a.747.747 0 00-.242-.34.628.628 0 00-.399-.124.638.638 0 00-.391.12.738.738 0 00-.24.331 1.396 1.396 0 00-.081.497zm3.096-.255V15h-.531v-3.636h.524v1.353h.034a.787.787 0 01.293-.35c.131-.087.303-.13.515-.13a1 1 0 01.49.116c.141.077.25.191.327.344.078.152.117.341.117.568V15h-.531v-1.67c0-.2-.052-.356-.155-.466a.556.556 0 00-.429-.167.705.705 0 00-.338.08.577.577 0 00-.232.234.756.756 0 00-.084.37zm2.827 1.653a.344.344 0 01-.25-.103.343.343 0 01-.105-.252c0-.097.035-.18.105-.249a.341.341 0 01.25-.105.34.34 0 01.25.105c.07.069.105.152.105.249a.368.368 0 01-.177.307.342.342 0 01-.178.048zm2.215.021c-.264 0-.491-.06-.682-.18a1.191 1.191 0 01-.437-.498 1.673 1.673 0 01-.152-.728c0-.277.052-.522.156-.733.104-.214.251-.38.44-.5.19-.119.413-.179.67-.179.207 0 .392.039.554.116a.991.991 0 01.392.32.953.953 0 01.179.48h-.516a.623.623 0 00-.196-.33.572.572 0 00-.404-.138.66.66 0 00-.389.117.759.759 0 00-.258.33c-.061.142-.092.31-.092.504 0 .2.03.37.091.515.06.145.145.257.255.336.111.08.242.119.393.119a.66.66 0 00.273-.055.562.562 0 00.208-.162.612.612 0 00.119-.252h.516a.993.993 0 01-.557.8c-.16.078-.347.118-.563.118zm2.837 0a1.25 1.25 0 01-.669-.176 1.18 1.18 0 01-.444-.492 1.623 1.623 0 01-.158-.738c0-.283.052-.53.158-.742.105-.212.253-.377.444-.494.19-.117.413-.176.669-.176.256 0 .479.059.669.176.191.117.339.282.444.494.106.211.158.459.158.742 0 .282-.052.528-.158.738a1.18 1.18 0 01-.444.492 1.25 1.25 0 01-.669.176zm.002-.446a.638.638 0 00.412-.131.768.768 0 00.241-.35c.053-.145.08-.306.08-.481 0-.174-.027-.334-.08-.48a.779.779 0 00-.241-.353.632.632 0 00-.412-.133.642.642 0 00-.416.133.79.79 0 00-.243.354 1.416 1.416 0 00-.078.479c0 .175.026.336.078.481a.779.779 0 00.243.35c.11.088.249.131.416.131zm1.862.391v-2.727h.509v.444h.034a.706.706 0 01.279-.352.82.82 0 01.463-.128c.183 0 .335.043.459.128a.75.75 0 01.275.352h.028a.768.768 0 01.311-.348.948.948 0 01.508-.132c.247 0 .449.078.605.233.158.155.236.389.236.701V15h-.531v-1.78c0-.184-.05-.318-.151-.4a.546.546 0 00-.36-.125.514.514 0 00-.403.16.58.58 0 00-.144.407V15h-.529v-1.813a.476.476 0 00-.138-.357.497.497 0 00-.361-.135.517.517 0 00-.279.08.586.586 0 00-.204.219.668.668 0 00-.076.325V15h-.531z",
    fill: "#808CB6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.999,
    cy: 14,
    r: 3,
    fill: "#D0D5E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.999,
    cy: 14,
    r: 3,
    fill: "#D0D5E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.999,
    cy: 14,
    r: 3,
    fill: "#D0D5E7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#createAppIllustration_svg__filter1_d_2325_132633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330 69a4 4 0 014-4h32a4 4 0 014 4v32a4 4 0 01-4 4h-32a4 4 0 01-4-4V69z",
    fill: "#626E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.924 83.917v-6.5h2.166v6.5h6.5v2.167h-6.5v6.5h-2.166v-6.5h-6.5v-2.167h6.5z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#createAppIllustration_svg__filter2_d_2325_132633)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.007,
    y: 147,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#A0A9CA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.258 158.067l-2.6 1.533-2.6 1.533-2.6 1.534v9.2l2.6-1.534 2.6-1.533v-3.067l-2.6 1.534V164.2l2.6-1.533 2.6-1.534v9.2l-2.6 1.534-2.6 1.533-2.6 1.533-2.6 1.534 2.6 1.533 2.6-1.533 2.6-1.534 2.6-1.533 2.6-1.533v-15.334l-2.6-1.533v3.067z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.007,
    y: 56,
    width: 111,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 48,
    width: 34,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 80,
    width: 34,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 100,
    width: 34,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 120,
    width: 34,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 140,
    width: 34,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 160,
    width: 136,
    height: 41,
    rx: 4,
    fill: "#F0F2FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121 215a4 4 0 014-4h128a4 4 0 014 4v7H121v-7z",
    fill: "#F0F2FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 64,
    width: 111,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 87,
    width: 111,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 107,
    width: 111,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 127,
    width: 111,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 147,
    width: 111,
    height: 3,
    rx: 1.5,
    fill: "#E3E7F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "createAppIllustration_svg__filter0_d_2325_132633",
    x: 25,
    y: 0,
    width: 334,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2325_132633"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2325_132633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2325_132633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "createAppIllustration_svg__filter1_d_2325_132633",
    x: 324,
    y: 59,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2325_132633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2325_132633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "createAppIllustration_svg__filter2_d_2325_132633",
    x: 6.007,
    y: 140,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2325_132633"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2325_132633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2325_132633",
    result: "shape"
  })))));
}

export default __webpack_public_path__ + "static/media/createAppIllustration.95516817.svg";
export { SvgCreateAppIllustration as ReactComponent };